import NavigationTop from './NavigationTop.vue'

export default NavigationTop
